import React from "react";
import { ConfirmDialog, useNotifications } from "sprint-common-web";

import { useOnPremAssetDetails } from "../../common/hooks/useOnPremAssetDetails";
import { useDeprecateOnPremAsset } from "./useDeprecateOnPremAsset";

interface DeprecateStatusDialogProps {
    isOpened: boolean;
    onDismiss: () => void;
}

export const DeprecateStatusDialog: React.FC<DeprecateStatusDialogProps> = ({
    isOpened,
    onDismiss
}: DeprecateStatusDialogProps) => {
    const { success, error } = useNotifications();
    const { data: assetDetails } = useOnPremAssetDetails();
    const { mutateAsync: deprecateOnPremAsset } = useDeprecateOnPremAsset({ invalidationKey: assetDetails?.assetId });

    const callOnConfirm = async () => {
        try {
            await deprecateOnPremAsset({ assetId: assetDetails?.assetId });

            success("Asset has been deprecated successfully.");
        } catch {
            error("Failed to deprecate asset.");
        } finally {
            onDismiss();
        }
    };

    return (
        <ConfirmDialog
            title={`Move to 'Deprecated'`}
            text={`Are you sure you want to deprecate individual asset?`}
            confirm={{ onClick: callOnConfirm }}
            cancel={{ onClick: onDismiss }}
            hidden={!isOpened}
            width={500}
        />
    );
};
